import { DataTableRow } from "../";

export const DataTableRowContent = ({
	page,
	prepareRow,
	isLoading = false,
	isError = false,
	isFetching = false,
}) => {
	if (isLoading) {
		return (
			<tr data-testid="test-rowContent">
				<td colSpan={100}>Loading Data...</td>
			</tr>
		);
	}

	if (isError) {
		return (
			<tr data-testid="test-rowContent">
				<td colSpan={100}>Error: Something's gone wrong!</td>
			</tr>
		);
	}

	if (page?.length) {
		return page.map((row, index) => (
			<DataTableRow
				index={index}
				key={`dataRow-${index}`}
				row={row}
				prepareRow={prepareRow}
			/>
		));
	}

	if (isFetching) {
		return (
			<tr data-testid="test-rowContent">
				<td colSpan={100}>Loading Data...</td>
			</tr>
		);
	}

	return (
		<tr data-testid="test-rowContent">
			<td colSpan={100}>No data found</td>
		</tr>
	);
};
